import React, { lazy, Suspense } from 'react'
import { Spinner } from '../../Spinner/Spinner'
import { getWindow } from '../../../helpers/UtilHelper'
import { useAppSelector } from '../../../hooks/useAppSelector'
import { ModalState } from '../../../states/modals/reducer'
import { ModalType } from '../../../states/modals/ModalType.constants'

const LazyComponent = lazy(() => import('../PaymentModal'))

const LazyPaymentModal = () => {
  const { modalType } = useAppSelector<ModalState>(({ modals }) => modals)
  if (!getWindow()) {
    return null
  }
  if (modalType !== ModalType.PAYMENT) {
    return null
  }
  return (
    <Suspense fallback={<Spinner />}>
      <LazyComponent />
    </Suspense>
  )
}

export default LazyPaymentModal
